import OverlayLoading from 'components/atoms/OverlayLoading'
import UnavoidableConfirmCancel from 'components/molecules/notificationOverlay/UnavoidableConfirmCancel'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { ADD_ASSESSMENT_RATERS, MY_JOURNEY } from 'routes/constants'
import {
  ASSESSMENT_QUESTIONS_SELF_URL,
  ASSESSMENT_URL
} from 'services/constants'
import { getRequest } from 'utils/api'
import { getGoalInfoById } from 'utils/getSupportingInfo'
import AssessmentCard from './AssessmentCard'
import { Typography } from '@mui/material'
import CommonDialog from 'components/molecules/notificationOverlay/CommonDialog'
import { AssessmentCompletePopup } from 'components/molecules/assessments/AssessmentMolecules'

const SelfAssessmentCard = ({
  goalId,
  nextStepCallback,
  previousStepCallback,
  showLandingPopup = false,
  cohortUser,
  fromOnboarding = false,
  setResultData = () => {}
}) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [goalData, setGoalData] = useState({})
  const [openAssessmentDialogOpen, setOpenAssessmentDialogOpen] =
    useState(false)
  const [questions, setQuestions] = useState([])
  const [landingDialogOpen, setLandingDialogOpen] = useState(showLandingPopup)
  const [congratsDialogOpen, setCongratsDialogOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  useState(() => {
    const fetchData = async () => {
      const data = await getGoalInfoById(goalId)
      setGoalData(data)
      const res = await getRequest(ASSESSMENT_URL, { goalId })
      if (res?.status === 200) {
        if (res.data.data.isOpen) {
          setOpenAssessmentDialogOpen(true)
          setLoading(false)
          return
        }
      }

      const quesRes = await getRequest(ASSESSMENT_QUESTIONS_SELF_URL, {
        goalId
      })
      if (quesRes.status === 200) {
        setQuestions(quesRes.data.data)
      }
      setLoading(false)
    }

    if (goalId) {
      setLoading(true)
      fetchData()
    }
  }, [goalId])

  const submittedCallback = result => {
    setResultData(result)
    if (fromOnboarding) {
      nextStepCallback()
    } else {
      setCongratsDialogOpen(true)
    }
  }

  const handleComplete = () => {
    setCongratsDialogOpen(false)
    nextStepCallback()
  }

  const handleOpenAssessmentRedirect = addRaters => {
    if (addRaters) {
      navigate(`${ADD_ASSESSMENT_RATERS}/${goalId}`)
    } else {
      navigate(MY_JOURNEY)
    }
  }
  return (
    <>
      {questions.length ? (
        <AssessmentCard
          selfAssessment={true}
          goalId={goalId}
          goalData={goalData}
          questions={questions}
          submittedCallback={submittedCallback}
          previousStepCallback={previousStepCallback}
        />
      ) : null}
      <OverlayLoading open={loading} />
      <UnavoidableConfirmCancel
        open={openAssessmentDialogOpen}
        subtitle={`${t('assessmentTimeline.alreadyCompletedSelfassessment')} ${t('assessmentTimeline.addMore360Raters')}`}
        highFocusAction={() => handleOpenAssessmentRedirect(true)}
        lowFocusAction={() => handleOpenAssessmentRedirect(false)}
        highFocusText={t('assessmentTimeline.addRaters')}
        lowFocusText={t('assessmentTimeline.returnMyJourney')}
      />
      <AssessmentCompletePopup
        congratsDialogOpen={congratsDialogOpen}
        handleComplete={handleComplete}
      />
      <CommonDialog
        open={landingDialogOpen}
        onClose={() => setLandingDialogOpen(false)}
        confirmText={t('common.ok')}
        titleText={t('assessments.completeFirst')}>
        <Typography>
          {t(
            cohortUser
              ? 'assessments.cohortPathAssessment'
              : 'assessments.nonCohortPathAssessment',
            { goalName: goalData.name }
          )}
        </Typography>
        {cohortUser && (
          <Typography>{t('assessments.cohortPathAssessment1')}</Typography>
        )}
      </CommonDialog>
    </>
  )
}

export default SelfAssessmentCard
